import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2024 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { Toggle } from "rsuite";
import { InfoTooltip } from "../general";
import { useEffect, useState } from "react";
import { upsertComponent } from "../boards/utils";
import RemoteFilters from "./RemoteFilters";
import { Drawer } from "../general";
import { generateFilter, resetFiltersBelow } from "./utils";
import { deepCopy } from "../general/utils";
import { TsDataSource } from "..";
function BoardFilters(props) {
    const { id, zone, setZone, entityType, endpoint, open, setOpen } = props;
    const ds = new TsDataSource();
    // the fixed filter present on the component
    const [filters, setFilters] = useState(deepCopy(entityType === "zone"
        ? zone.defaultFilter
        : zone.components[id].data.defaultFilter));
    const [passThrough, setPassThrough] = useState(entityType === "zone"
        ? true
        : deepCopy(zone.components[id].data).filterPassThrough);
    const removeCurrentEntityFiltersForDisabledFilters = (source = {}, remove) => {
        const keysToRemove = new Set(Object.keys(remove || {}));
        return Object.fromEntries(Object.entries(source).filter(([key]) => !keysToRemove.has(key)));
    };
    // getting the disabled filter values (currently all other entity filters)
    const [disabledFilterValues, setDisabledFilterValues] = useState(removeCurrentEntityFiltersForDisabledFilters(generateFilter(zone, undefined, true)?.and_, filters?.and_));
    useEffect(() => {
        setFilters(deepCopy(entityType === "zone"
            ? zone.defaultFilter
            : zone.components[id].data.defaultFilter));
        setDisabledFilterValues(removeCurrentEntityFiltersForDisabledFilters(generateFilter(zone, undefined, true)?.and_, filters?.and_));
        setPassThrough(entityType === "zone"
            ? false
            : deepCopy(zone.components[id].data).filterPassThrough);
    }, [open]);
    const onSave = (filter, filterPassThrough) => {
        let componentAttributes = {
            filter: filter
        };
        if (entityType === "zone") {
            zone.filter = deepCopy(filter);
            zone.defaultFilter = deepCopy(filter);
        }
        else {
            zone.components[id].data.filter = deepCopy(filter);
            zone.components[id].data.defaultFilter = deepCopy(filter);
            zone.components[id].data.filterPassThrough = filterPassThrough;
            componentAttributes["filter_pass_through"] = filterPassThrough;
        }
        resetFiltersBelow({ id: id, zone: zone });
        setZone({ ...zone });
        setOpen(false);
        upsertComponent(ds, id, componentAttributes);
    };
    return (_jsx("div", { children: _jsxs(Drawer, { title: `Filtering on a ${endpoint} ${entityType}`, open: open, setOpen: setOpen, children: [entityType !== "zone" ?
                    _jsxs("div", { className: "passThrough-toggle", children: [_jsx(Toggle, { onClick: () => {
                                    setPassThrough(!passThrough);
                                    setZone({ ...zone });
                                }, checked: passThrough }, "recommended-tick-filter"), _jsx("span", { style: { paddingRight: 6 }, onClick: (e) => e.stopPropagation(), children: "Apply filters only to this Component." }), _jsx(InfoTooltip, { contents: "This filter does not affect other components in the heirarchy. Filters from above are still applied." }), _jsx("hr", { style: { marginTop: 24 } })] })
                    : null, _jsx(RemoteFilters, { ...props, filters: filters, filterPassThrough: passThrough, onSave: onSave, disabledFilterValues: disabledFilterValues })] }) }));
}
export default BoardFilters;
